import { Box, Grid } from '@mui/material';
import { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { GenericDialog } from 'src/shared/components/organisms/genericDialog';
import LoadingOverlay from 'src/shared/components/organisms/loadingOverlay';
import ConsoleHelper from 'src/shared/functions/consoleHelper';
import { useIsMounted } from 'src/shared/hooks/useIsMounted';
import { getMemberCard } from 'src/shared/services/memberService';

type MemberMeMemberCardModalProps = {
  modalOpen: boolean;
  onClose: () => void;
  memberId: number;
};

export const MemberMeMemberCardModal = (props: MemberMeMemberCardModalProps) => {
  const { modalOpen, onClose, memberId } = props;
  const { t } = useTranslation();
  const isMounted = useIsMounted();

  const [memberCard, setMemberCard] = useState<string | undefined>();
  const [isLoading, setIsLoading] = useState<boolean>(true);

  const fetchMemberCard = useCallback(async () => {
    try {
      const res = await getMemberCard(memberId);
      if (isMounted()) {
        ConsoleHelper.log('MemberCard RES: ', res);
        setMemberCard(res.data);
      }
    } catch (error) {
      if (isMounted()) {
        ConsoleHelper.log(error);
      }
    } finally {
      if (isMounted()) {
        setIsLoading(false);
      }
    }
  }, [isMounted, memberId]);

  useEffect(() => {
    fetchMemberCard();
  }, [fetchMemberCard]);

  const onCloseHandler = () => {
    onClose();
  };
  return (
    <GenericDialog
      open={modalOpen}
      onClose={onCloseHandler}
      onSave={onCloseHandler}
      maxWidth='xs'
      dialogTitle={t('member:memberCard')}
      showDialogActions={false}
      dialogContent={
        !memberCard && isLoading ? (
          <Grid container py={15}>
            <LoadingOverlay loading={isLoading} />
          </Grid>
        ) : (
          <Grid container>
            <Grid item xs={12}>
              <Box component='img' sx={{ height: 'auto', width: '100%' }} src={`data:image/png;base64,${memberCard}`} alt={t('member:memberCard')} />
            </Grid>
          </Grid>
        )
      }
    />
  );
};
